// app/javascript/services/demissoes_approvals_service.js

function tokenFromMeta() {
  const el = document.querySelector('meta[name="csrf-token"]');
  return el ? el.getAttribute("content") : null;
}

function tokenFromRailsUjs() {
  try {
    if (window.Rails && typeof window.Rails.csrfToken === "function") {
      return window.Rails.csrfToken();
    }
  } catch (e) { }
  return null;
}

function csrfToken() {
  return tokenFromMeta() || tokenFromRailsUjs();
}

function normalizeUrlToPath(url) {
  if (!url) return url;

  let stripped = String(url).replace(/^https?:\/\/[^/]+/i, "");
  if (stripped[0] !== "/") {
    try {
      const parsed = new URL(url, window.location.origin);
      stripped = parsed.pathname + parsed.search + parsed.hash;
    } catch (e) {
      stripped = "/" + stripped;
    }
  }
  return stripped;
}

function extractErrorMessage(resp) {
  try {
    if (resp && resp.responseJSON) {
      if (resp.responseJSON.error) return resp.responseJSON.error;
      if (resp.responseJSON.message) return resp.responseJSON.message;
    }
  } catch (e) { }
  return "Falha ao processar. Verifique console/log.";
}

function postWithCsrf(url, data) {
  const token = csrfToken();
  const payload = data || {};
  const pathUrl = normalizeUrlToPath(url);

  if (token) payload["authenticity_token"] = token;

  return $j.ajax({
    url: pathUrl,
    method: "POST",
    data: payload,
    crossDomain: false,
    xhrFields: { withCredentials: true },
    headers: token ? { "X-CSRF-Token": token } : {},
  });
}

export function createDemissoesApprovalsService({ bulkUrl }) {
  return {
    async confirmCancel() {
      const result = await Swal.fire({
        title: "Cancelar minha aprovação?",
        html: '<p class="text-center">Deseja cancelar sua aprovação desta solicitação?</p>',
        icon: "warning",
        confirmButtonText: "Sim, cancelar",
        confirmButtonColor: "#d33",
        showCancelButton: true,
        cancelButtonColor: "#6b7280",
        cancelButtonText: "Voltar",
        showCloseButton: true,
      });

      return !!result.isConfirmed;
    },

    async confirmBulkApprove(count) {
      const result = await Swal.fire({
        title: "Aprovar demissões?",
        html:
          '<p class="text-center">Você irá aprovar <b>' +
          count +
          "</b> solicitação(ões) de demissão.</p>",
        icon: "question",
        confirmButtonText: "Sim, aprovar",
        confirmButtonColor: "#28a745",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        showCloseButton: true,
      });

      return !!result.isConfirmed;
    },

    async bulkApprove(ids) {
      if (!bulkUrl) throw new Error("bulkUrl não informado.");
      return postWithCsrf(bulkUrl, { ids });
    },

    async cancelApproval(url) {
      if (!url) throw new Error("URL de cancelamento não informada.");
      return postWithCsrf(url, {});
    },

    showError(title, respOrMessage) {
      const msg =
        typeof respOrMessage === "string"
          ? respOrMessage
          : extractErrorMessage(respOrMessage);

      return Swal.fire({
        title: title || "Erro",
        html: '<p class="text-center">' + msg + "</p>",
        icon: "error",
      });
    },
  };
}
